import React, { createContext, useContext, useState, ReactNode } from "react";

interface LoaderContextType {
  loading: boolean;
  warningText: string | null;
  showPayloadUploadLoader: (warning?: string) => void;
  hidePayloadUploadLoader: () => void;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

interface LoaderProviderProps {
  children: ReactNode;
}

export const PayloadUploadLoaderProvider: React.FC<LoaderProviderProps> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [warningText, setWarningText] = useState<string | null>(null); 

  const showPayloadUploadLoader = (warning?: string) => {
    setWarningText(warning || null);
    setLoading(true);
  };

  const hidePayloadUploadLoader = () => {
    setLoading(false);
    setWarningText(null); 
  };

  return (
    <LoaderContext.Provider value={{ loading, warningText, showPayloadUploadLoader, hidePayloadUploadLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const usePayrollUploadLoader = (): LoaderContextType => {
  const context = useContext(LoaderContext);
  if (context === undefined) {
    throw new Error("useLoader must be used within a PayloadUploadLoaderProvider");
  }
  return context;
};
